import StoresMovement       from '@/components/frontOffice/StoresMovement.vue'
import SmartStoresMovement  from '@/components/frontOffice/SmartStoresMovement.vue'


const menuId = 'fo2'
const routes = [

    
    
    {
        path        : '/stores/movement', 
        component   : StoresMovement,
        name        : 'storeMovement',
        meta        : { name : 'Lista Trasferimenti', menu:menuId, visible : true ,icon : 'fas fa-shipping-fast',menu:menuId,color:'#666600'},   
    },
    {
        path        : '/smart/movement', 
        component   : SmartStoresMovement,
        name        : 'smartStoreMovement',
        meta        : { name : 'Trasferimento Smart',menu:menuId, visible : true ,icon : 'fas fa-camera',menu:menuId,color:'#660066'},   
    },

]
export default routes
